export default {
  install (Vue, options) {
    Vue.mixin({
      created () {
        if (this.$options.Resource) this.$api.register(this.$options.Resource, this._uid)
      },
      beforeDestroy () {
        this.$nextTick(() => {
          if (this.$options.Resource) this.$api.unregister(this.$options.Resource, this._uid)
        })
      }
    })
  }
}
